import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Бренд FastFresh — те же токены, что в лендинге и packages/ui/theme.css:
// лайм #a3e635 (lime-400) акцентом, тёмная основа #0a0a0a, карточки #141414, Inter, скругления 16/24.
// Шкала лайма — Tailwind lime 50…900: в тёмной теме берём 400, в светлой — 600 (контраст на белом).
const brand: MantineColorsTuple = [
    '#f7fee7',
    '#ecfccb',
    '#d9f99d',
    '#bef264',
    '#a3e635',
    '#84cc16',
    '#65a30d',
    '#4d7c0f',
    '#3f6212',
    '#365314',
];

// Тёмная шкала Mantine: [0] текст, [2] приглушённый, [4] границы, [6] карточки/инпуты, [7] фон страницы.
const dark: MantineColorsTuple = [
    '#f0f0f0',
    '#cccccc',
    '#a0a0a0',
    '#888888',
    '#2a2a2a',
    '#242424',
    '#141414',
    '#0a0a0a',
    '#070707',
    '#050505',
];

const yellow: MantineColorsTuple = [
    '#fefce8',
    '#fef9c3',
    '#fef08a',
    '#fde047',
    '#facc15',
    '#eab308',
    '#ca8a04',
    '#a16207',
    '#854d0e',
    '#713f12',
];

export const theme = createTheme({
    primaryColor: 'brand',
    primaryShade: { light: 6, dark: 4 },
    autoContrast: true,
    luminanceThreshold: 0.4,
    colors: { brand, dark, yellow },
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    headings: {
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
        fontWeight: '800',
    },
    defaultRadius: 'md',
    radius: { xs: '6px', sm: '10px', md: '12px', lg: '16px', xl: '24px' },
    cursorType: 'pointer',
    components: {
        Card: { defaultProps: { radius: 'lg', withBorder: true, padding: 'lg' } },
        Paper: { defaultProps: { radius: 'lg' } },
        Modal: { defaultProps: { radius: 'lg', centered: true, overlayProps: { blur: 3 } } },
        // overflow: visible — иначе в узкой колонке таблицы бейдж сжимается до «АК…».
        Badge: { defaultProps: { radius: 'sm', variant: 'light' }, styles: { label: { overflow: 'visible' } } },
        Button: { defaultProps: { radius: 'md' } },
    },
});
